import React from 'react';
import { cn } from '../../lib/utils';
import { Avatar, AvatarImage } from './avatar';
import { NavigationMenuLink } from './navigation-menu';

export type ListItemProps = React.ComponentPropsWithoutRef<'a'> & {
	title: string;
	imageUrl?: string | null;
	Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
	children?: React.ReactNode;
};

const ListItem = React.forwardRef<React.ElementRef<'a'>, ListItemProps>(
	({ className, title, Icon, imageUrl, children, ...props }, ref) => {
		return (
			<li>
				<NavigationMenuLink asChild>
					<a
						ref={ref}
						className={cn(
							'block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground',
							className
						)}
						{...props}
					>
						<div className="flex items-center space-x-3">
							{Icon ? (
								<Icon className="w-6 h-6" />
							) : (
								<>
									{imageUrl && (
										<Avatar className="shrink-0">
											<AvatarImage
												src={imageUrl}
												alt={title}
											/>
										</Avatar>
									)}
								</>
							)}
							<div>
								<div className="text-sm font-medium leading-none">
									{title}
								</div>
								<p className="line-clamp-2 text-muted-foreground text-sm leading-snug">
									{children}
								</p>
							</div>
						</div>
					</a>
				</NavigationMenuLink>
			</li>
		);
	}
);
ListItem.displayName = 'ListItem';

export default ListItem;
